import { types } from "../action_types";

const initialState = {
  seasons: null,
  seasonsLoading: false,
  createLoading: false,
  updateLoading: false,
};

const SeasonsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GetSeasonsRequest:
      return { ...state, seasonsLoading: true };
    case types.GetSeasonsRequestSuccess:
      return { ...state, seasons: action.payload, seasonsLoading: false };
    case types.GetSeasonsRequestFailure:
      return { ...state, seasonsLoading: false };

    case types.CreateSeasonRequest:
      return { ...state, createLoading: true };
    case types.CreateSeasonRequestSuccess:
      return { ...state, createLoading: false };
    case types.CreateSeasonRequestFailure:
      return { ...state, createLoading: false };

    case types.UpdateSeasonRequest:
      return { ...state, updateLoading: true };
    case types.UpdateSeasonRequestSuccess:
      return { ...state, updateLoading: false };
    case types.UpdateSeasonRequestFailure:
      return { ...state, updateLoading: false };

    default:
      return state;
  }
};

export default SeasonsReducer;
